import { AuthRoutes } from 'auth/config';
import { AdminRoutes } from 'admin/config/routes';
import { AbstractRoute } from 'common/utils/routes';
export var Routes = [
    { path: '/auth', component: AbstractRoute, children: AuthRoutes, meta: { title: 'Enrolment Assistant' } },
    { path: '/', component: AbstractRoute, children: AdminRoutes, meta: { title: 'Enrolment Assistant Admin' } }
];
